import api from '@/lib/api'
import { onMounted, ref } from 'vue'

const favourites = ref({})

async function fetchFavourites () {
  favourites.value = await api.getFavourites()
}

async function addFavourite (id, type) {
  await api.addFavourite({ id, type })
  await fetchFavourites()
}

async function removeFavourite (id, type) {
  await api.removeFavourite({ id, type })
  await fetchFavourites()
}

export function useFavourites () {
  if (!Object.keys(favourites.value).length) {
    onMounted(fetchFavourites)
  }
  return {
    favourites,
    addFavourite,
    removeFavourite,
  }
}
